import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import TextBox from 'components/common/text_box'
import styles from './edit_name.less'
import EditForm from '../edit_form'

const i18n = getI18n('components/edit_glimpse/edit_name')

class EditName extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    fields: PropTypes.object.isRequired,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
  }

  render() {
    const {
      fields: { title },
      anyInactiveFieldsTouchedWithError,
    } = this.props

    return (
      <EditForm {...this.props}>
        <div styleName="title" role="heading" aria-level="1">
          {i18n('title')}
        </div>
        <TextBox
          dataNemo="goalName"
          title={i18n('goal_name')}
          {...title}
          autoFocus={true}
        />
        <button
          data-pa-click="save"
          data-nemo="save"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditName, styles)
